
import Header from '@/components/header.vue';
import { defineComponent, reactive, ref } from 'vue';
import { List, Icon, PullRefresh } from 'vant';
import { useRouter } from 'vue-router';
import getList from '@/http/stayCase';

export default defineComponent({
  components: {
    [List.name]: List,
    [Icon.name]: Icon,
    [PullRefresh.name]: PullRefresh,
    Header,
  },
  setup() {
    const router = useRouter();
    const state = reactive({
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
    });
    const pages = reactive({
      pageNo: 0,
      pageSize: 5,
    });
    const colorList = ref(['#A7ffd9', '#fffca7', '#dec8ff']);
    const onLoad = () => {
      pages.pageNo += 1;
      getList(pages).then((res: any) => {
        const { total } = res.result;
        const {
          result: { records },
        }: { result: { records: [] } } = res;
        state.refreshing = false;
        state.list.push(...records);
        state.loading = false;
        if (state.list.length === total) {
          state.finished = true;
        }
      });
    };
    const onRefresh = () => {
      state.list = [];
      pages.pageNo = 0;
      onLoad();
    };
    const onJump = (pro:any) => {
      router.push({
        path: '/caseForm',
        query: { projectId: pro, type: 1 },
      });
    };
    return {
      state,
      onLoad,
      colorList,
      onRefresh,
      onJump,
    };
  },
});
